import React from 'react';
import styles from './styles'
import {CSVLink} from 'react-csv'
import Collapsable from "../Common/Collapsable";

const UploadsList = (props) => {
  const styling = styles.uploadList
  const csvLink = React.useRef()
  const [data, setData] = React.useState([])

  const download = async (e, id) => {
    await props.downloadUpload(id, props.user).then(file => {
      setData(file)
    })
    csvLink.current.link.click()
  }

  const icon = (upload) => <svg onClick={(e) => download(e, upload._id)} style={styling.icon} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path xmlns="http://www.w3.org/2000/svg" d="M216 0h80c13.3 0 24 10.7 24 24v168h87.7c17.8 0 26.7 21.5 14.1 34.1L269.7 378.3c-7.5 7.5-19.8 7.5-27.3 0L90.1 226.1c-12.6-12.6-3.7-34.1 14.1-34.1H192V24c0-13.3 10.7-24 24-24zm296 376v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h146.7l49 49c20.1 20.1 52.5 20.1 72.6 0l49-49H488c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z"/></svg>

  return <div style={styling.container}>
    {props.uploads.analytics && <div style={{marginBottom: 8}}>
      <p className='heading' style={{marginRight:'auto', marginBottom: 10}}>Analytics from latest update</p>
      <div>
        {props.uploads.analytics.no_xm && <Collapsable list={props.uploads.analytics.no_xm} title="Not mapped to oncology"/>}
        {props.uploads.analytics.no_master && <Collapsable list={props.uploads.analytics.no_master} title="Not in CT.gov database"/>}
        {props.uploads.analytics.obs && <Collapsable list={props.uploads.analytics.obs} title="Observational studies"/>}
      </div>
    </div>}
    <p className='heading' style={{marginRight:'auto', marginBottom: 10}}>Uploaded</p>
    {props.uploads.uploads.map((upload, i) => <div style={styling.listItem} key={i}>
      <p style={styling.itemText}><b>Date:</b> {upload.upload_date}</p>
      <p style={styling.itemText}><b>User:</b> {upload.user}</p>
      {upload.fileAnalytics && <React.Fragment>
        <p style={styling.itemText}><b>New Trials:</b> {upload.fileAnalytics.newTrials}</p>
        <p style={styling.itemText}><b>Removed Trials:</b> {upload.fileAnalytics.removedTrials}</p>
        <p style={styling.itemText}><b>Total Trials:</b> {upload.fileAnalytics.trialCount}</p>
      </React.Fragment>}
      <div style={styling.actions}>
        {icon(upload)}
      </div>
    </div>)}
    <CSVLink data={data} filename='bulkUploads.csv' style={{visibility: 'hidden'}} ref={csvLink} target='_blank'/>
  </div>
}

export default UploadsList;
